import { Center, Modal, ModalBody, ModalContent, ModalOverlay, Spinner } from '@elkaso-app/web-design';
import { useGetMasterProductApi } from 'apis/master-products';
import type { RestaurantInquiryItem } from 'apis/restaurant-inquiries';
import { VariantFormModal } from 'pages/inquiry-processor/components/master-product-families/variant-form-modal';

interface Props {
  item: RestaurantInquiryItem;
  onClose: () => void;
}

// Fix master data right where its gap is visible (the quotation workbench).
// Fetches the FULL master product first — the inquiry's masterProduct summary
// is a subset, and VariantFormModal PUTs a complete payload, so seeding from
// the summary would clobber unlisted fields. Hosts the same VariantFormModal
// the families screen uses; the caller invalidates the inquiry query on close
// so the request panel and suggestion ranking pick up the fix.
export const EditMasterProductModal = ({ item, onClose }: Props) => {
  const { data: product } = useGetMasterProductApi(item.masterProductId);

  if (!product) {
    return (
      <Modal isOpen onClose={onClose} size='xs'>
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <Center py='6'>
              <Spinner />
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  }

  return (
    <VariantFormModal
      isOpen
      onClose={onClose}
      familyId={product.familyId}
      familyImageUrl={product.family?.imageUrl}
      product={product}
    />
  );
};
